import React from 'react';
import {Container} from 'react-bootstrap';
import {Link,useParams} from 'react-router-dom';
import DriverSupport from '../components/driver/DriverSupport';
export default function CustomerSupport(){
 const {caseId}=useParams();
 return <Container className="py-4" style={{maxWidth:960}}><Link to="/dashboard">Back to customer dashboard</Link><h1 className="my-3">Customer support</h1><DriverSupport portal="customer" caseId={caseId}/></Container>;
}
